import { Box, Button, Typography, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import LogoSe from "../../../../../media/images/icons/logoSecondary.svg";
import NotifsIcon from "../../../../../media/images/icons/notification-bing";
import WalletEmpty from "../../../../../media/images/icons/empty-wallet.svg";

export default function DashboardHeader() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          backgroundColor: "background.default",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "4px",
          borderRadius: "12px",
        }}
      >
        <img width={40} src={LogoSe} alt="" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              fontSize: "12px",
              color: "secondary.main",
            }}
          >
            بازارگاه
          </Typography>
          <Typography
            sx={{
              fontWeight: "600",
              color: "secondary.main",
            }}
          >
            کارن ترابرنت
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "background.default",
          padding: "4px",
          borderRadius: "8px",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "info.light",
            height: "100%",
            padding: "4px",
            borderRadius: "8px",
          }}
        >
          <img src={WalletEmpty} alt="" />
          <Typography>260,000 ریال</Typography>
        </Box>
        <Button
          onClick={() => navigate("/notifs")}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid gray",
            minWidth: "0px !important",
            //   gap: "8px",
            borderColor: `${theme.palette.secondary.main} !important`,
            backgroundColor: `${theme.palette.secondary.light} !important`,
            "& .MuiTouchRipple-root": {
              color: `${theme.palette.secondary.main} !important`,
              borderWidth: "0px !important",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.secondary.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          <NotifsIcon color={theme.palette.secondary.dark} />
        </Button>
      </Box>
    </Box>
  );
}
